import { createIcon } from './create-icon'

export const CollapseIcon = (): SVGSVGElement => createIcon(['M4 14h6v6', 'M20 10h-6V4', 'M14 10l7-7', 'M3 21l7-7'])
